/** Fields whose natural order is newest first. */
const NEWEST_FIRST_FIELDS = ['added_at'];

/**
 * The sort to apply when the admin picks `field`: Added starts newest first, the rest keep the
 * current direction. Picking the field already in use changes nothing.
 */
export const getSortForField = (field, current) => {
  if (field === current.field) return current;
  return { field, direction: NEWEST_FIRST_FIELDS.includes(field) ? 'desc' : current.direction };
};
